import { render, staticRenderFns } from "./coupon-center.vue?vue&type=template&id=caf5f51e&"
import script from "./coupon-center.vue?vue&type=script&lang=js&"
export * from "./coupon-center.vue?vue&type=script&lang=js&"
import style0 from "./coupon-center.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports